export default __webpack_public_path__ + "static/media/wxxd.09766951.png";